import React from "react";

interface Props
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {}

const LoadingPlaceholder = (props: Props) => {
  return <div {...props} className={[props.className, "LoadingPlaceholder"].join("")} />;
};

export default React.memo(LoadingPlaceholder);
